import { useEffect } from 'react';

const FreshchatWidget = () => {
  useEffect(() => {
    // Only load Freshchat if it hasn't been loaded already
    if (window.fcWidget) {
      return;
    }

    // Create script element
    const script = document.createElement('script');
    script.src = "//eu.fw-cdn.com/12777158/762750.js";
    script.setAttribute('chat', 'true');
    script.async = true;
    
    // Insert script into DOM
    document.head.appendChild(script);
    
    // Cleanup function
    return () => {
      // Remove script if component unmounts
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  // This component doesn't render anything visible
  return null;
};

export default FreshchatWidget;